import { Source } from "@opendash/plugin-parse/dist/types-generated";
import Parse from "parse";
import { useEffect, useState } from "react";
import { Media, Source_File } from "../../../js/parsegenerated";

export default (sourceId?: string) => {
  const [reload, setReload] = useState(false);
  const [sourceFile, setSourceFile] = useState<Source_File>(undefined);
  const [media, setMedia] = useState<Media[]>([]);

  useEffect(() => {
    async function fetchSourceFile() {
      try {
        // Fetch all source files, maybe depending on source
        const fetchedFile = await new Parse.Query(Source_File)
          .include("source")
          .include("files")
          .equalTo("source", new Source({ objectId: sourceId }))
          .first();

        const fetchedMedia =
          (await fetchedFile?.get("files").query().find()) ?? [];
        setMedia(fetchedMedia);
        setSourceFile(fetchedFile);
      } catch (e) {
        console.error(e);
      }
    }

    fetchSourceFile();
  }, [reload, sourceId]);

  function reloadSouceFile() {
    setReload((prev) => !prev);
  }

  return {
    sourceFile,
    media,
    reload: reloadSouceFile,
  };
};
